import styled from '@emotion/styled';
import {Button, Dialog, TextField} from '@bosch/react-frok';

export const DialogWrapper = styled(Dialog)`
    .m-dialog__actions {
        display: grid;
        grid-template-columns: max-content auto max-content;
        justify-content: normal;
        margin-top: 0;
        width: 100%;
    }
`;

export const TextWrapper = styled.div`
    font-size: small;
    white-space: pre-line;

    & > p {
        margin-top: 0;
        font-size: 1rem;
    }
`;

export const TextInputShort = styled(TextField)`
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
    justify-content: center;
    align-self: center;
    align-items: stretch;
    width: 100%;
`;

export const DialogEditActionsWrapper = styled.div`
    display: inline-grid;
    grid-template-columns: 1fr;
    column-gap: 0.5rem;
    width: 100%;
`;

export const ActionButton = styled(Button)<{ fontSize: number }>`
    margin: 0;
    min-width: 120px;
    max-width: 240px;
    height: 48px;
    font-size: ${(props) => props.fontSize}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
